import React from 'react';

import { 
  StyledList,
  ListItem,
  Link,
} from './styled-components';

/**
 * 
 * @param {array} items - a list of links with title and url
 * @param {string} active - the currently active title
 */
const CategoryBar = ({ items }) => {
  return (
    <StyledList>
      {items.map(item => {
          return (<ListItem active={item.active} key={item.title}>
            <Link href={item.url}>{item.title}</Link>
          </ListItem>);
        })}
    </StyledList>
  );
}

export default CategoryBar;